import { Component, Input, ViewChild, ElementRef, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    templateUrl: './confirm.template.html',
})
export class ConfirmComponent implements OnInit {

    @Input()
    public question: string;

    @ViewChild('yesBtn', {static: true})
    public yesBtn: ElementRef;

    constructor(
        private _activeModal: NgbActiveModal,
    ) {}

    public ngOnInit(): void {
        // if not wrapped in timeout, scroll position changes
        setTimeout(() => {
            this.yesBtn.nativeElement.focus();
        });
    }

    public onYesClick(): void {
        this._activeModal.close();
    }

    public onNoClick(): void {
        this._activeModal.dismiss();
    }

    public onCancelClick(): void {
        this._activeModal.dismiss();
    }

}
